export default __webpack_public_path__ + "static/160-8b61473b584e648e120b3fa09eaf3866.jpg";